import { useMemo, useState } from 'react';

export interface UseBoolHandlers {
    on: () => void;
    off: () => void;
    toggle: () => void;
    reset: () => void;
}

export const useBool = (initialValue = false): [boolean, UseBoolHandlers] => {
    const [state, setState] = useState<boolean>(initialValue);

    const handlers = useMemo<UseBoolHandlers>(
        () => ({
            on: () => {
                setState(true);
            },
            off: () => {
                setState(false);
            },
            toggle: () => {
                setState(current => !current);
            },
            reset: () => {
                setState(initialValue);
            },
        }),
        [initialValue]
    );

    return [state, handlers];
};
